import { TOOL } from '@/api/apiModules'
import lang from '@/lang'
import dictionary from '@/utils/dictionary'
export default {
  viewType: 'table',
  module: TOOL,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  allowStatus: {
    ToolOffShelf: { toolStatus: ['ON_SHELF'] },
    ToolOnShelf: { toolStatus: ['OFF_SHELF'] }
  },
  toolbar: {
    searchWidth: 420,
    searchPlaceholder: '程序名称/工具名称/工具用途/使用场景',
    searchFieldNameArr: ['toolName', 'toolDesc', 'toolDetail', 'toolScene'],
    tips: {
      label: '注：本模块可以查询运维服务台及东风同步过来的数据，工具分类与工具发布范围不进行同步',
      type: 'warning'
    },
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'ToolCreate'
      }
    ]
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '工具名称',
          prop: 'toolDesc',
          sortField: 'toolName',
          width: 180
        },
        action: 'ToolDetail',
        dataType: 'link'
      },
      {
        props: {
          label: '工具Logo',
          prop: 'toolLogoBase64',
          width: 100
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data || !data.toolLogoBase64) {
            return
          }
          return [<img src={`${data.toolLogoBase64}`} style={{ width: '38px', height: '38px' }} />]
        }
      },
      {
        props: {
          label: '工具用途',
          prop: 'toolDetail'
        }
      },
      {
        props: {
          label: '使用场景',
          prop: 'toolScene'
        }
      },
      {
        props: {
          label: '工具来源',
          prop: 'toolSource',
          sortField: 'toolSource',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'toolSource'
      },
      {
        props: {
          label: '工具分类',
          prop: 'toolCategory',
          sortField: 'toolCategory',
          width: 120
        },
        filter: true,
        dataType: 'custom',
        custom: function(data, h) {
          if (!data || !data.toolCategory) {
            return
          }
          const renderItem = []

          data.toolCategory.split(',').forEach(el => {
            renderItem.push(
              <div class="custom-tag">
                <el-tag type={dictionary['toolCategory'][el].type}>
                  {lang.t(dictionary['toolCategory'][el].label)}
                </el-tag>
              </div>
            )
          })

          return renderItem
        }
      },
      {
        props: {
          label: '状态',
          prop: 'toolStatus',
          sortField: 'toolStatus',
          width: 100
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'toolStatus'
      },
      {
        props: {
          label: '创建人',
          prop: 'realName',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '3',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'ToolEdit',
        name: 'ToolEdit'
      },
      {
        icon: 'el-icon-upload',
        label: '上架',
        command: 'ToolOnShelf',
        name: 'ToolOnShelf',
        tip: '处于下架工具才允许上架操作'
      },
      {
        icon: 'sk-icon-invisible',
        label: '下架',
        command: 'ToolOffShelf',
        name: 'ToolOffShelf',
        tip: '处于上架工具才允许下架操作'
      },
      {
        icon: 'el-icon-download',
        label: '下载',
        command: 'ToolDownload',
        name: 'ToolDownload'
      }
    ]
  }
}
